import { Model } from 'modules/core/lib/mobx-rest'

interface IShift {
  employee_id: number
  end_at: string
  extra_hours?: boolean
  id: number
  is_overnight_by_calendar_day: boolean
  location_id?: number
  notes?: string
  shift_configuration_id?: number
  start_at: string
  state: string
  work_area_id: number
  color: string
  default_shift_id?: number
  template_week_id?: number
  unassigned_shift_id?: number
}

class Shift extends Model<IShift> {
  static urlRoot() {
    return '/shift_management/shifts'
  }
}

export default Shift
